import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";
import PolicyMixin from "@/mixins/PolicyMixin";
import EndorsementMixin from "@/mixins/EndorsementMixin";
import FormMixin from "@/mixins/FormMixin";
const TYPE_PAYMENT = { nome: "Pagamento", id: "pagamento" };
const MOCK_FORM = {
  apolice: [],
  boletos: [],
  fator_premio: null,
  motivo_cancelamento: null,
  segurado: {
    endereco: {}
  },
  anexos: [],
  prorrogar_vigencia: false,
  sem_movimento_premio: false,
  valor_premio: 0,
  novo_fim_vigencia: null,
  parcelas: [],
  processo: {
    segmento: {
      id: "justica_trabalho"
    }
  }
};
export default {
  mixins: [LoadingRequest, PolicyMixin, EndorsementMixin, FormMixin],
  created() {
    Promise.all([
      this.fetchItemsEndorsement(),
      this.fetchTypeEndorsement(),
      this.fetchCurrentPolicy(),
      this.fetchPayment()
    ]);
  },
  computed: {
    ...mapState("policy", ["currentPolicy", "currentRequestEndorsement"]),
    emptyCurrentPolicy() {
      if (!this.currentPolicy.tomador.nome_fantasia) {
        return true;
      }

      var sameID = this.currentPolicy.id == this.$route.params.id;
      return !sameID;
    }
  },
  methods: {
    ...mapActions("policy", [
      "requestListTypeEndorsement",
      "requestCurrentPolicy",
      "requestNewRequestEndorsement",
      "requestNewEndorsement",
      "requestItemsEndorsement"
    ]),
    ...mapActions("insuranceCompany", ["requestPaymentMethods"]),
    fetchPayment() {
      this.withLoading(this.requestPaymentMethods());
    },
    fetchTypeEndorsement() {
      this.withLoading(this.requestListTypeEndorsement());
    },
    fetchItemsEndorsement() {
      this.withLoading(this.requestItemsEndorsement(this.$route.params.id));
    },
    async submitNewRequestEndorsement(form) {
      this.withLoading(
        this.requestNewRequestEndorsement(
          await this.payloadNewRequestEndorsement(form)
        ).then(() => {
          this.modal = true;
          this.cancel = true;
        })
      );
    },
    async submitNewEndorsement(form) {
      this.withLoading(
        this.requestNewEndorsement(await this.payloadNewEndorsement(form)).then(
          () => {
            this.modal = true;
            this.cancel = true;
          }
        )
      );
    },
    async payloadNewEndorsement(form) {
      return {
        id: this.$route.params.id,
        payload: await this.getPayloadEndorsement(form)
      };
    },
    async payloadNewRequestEndorsement(form) {
      return {
        id: this.$route.params.id,
        payload: await this.getPayloadRequestEndorsement(form)
      };
    },
    fetchCurrentPolicy() {
      this.withLoading(this.requestCurrentPolicy(this.$route.params.id));
    },
    updateForm() {
      if (this.emptyCurrentPolicy) {
        return;
      }

      this.form = _.cloneDeep({
        ..._.pick(MOCK_FORM, [
          "apolice",
          "boletos",
          "prorrogar_vigencia",
          "sem_movimento_premio",
          "parcelas",
          "novo_fim_vigencia",
          "valor_premio",
          "anexos",
          "motivo_cancelamento",
          "fator_premio"
        ]),
        ..._.pick(this.currentPolicy, [
          "segurado",
          "processo",
          "comentario",
          "numero_controle_interno",
          "forma_pagamento"
        ])
      });

      this.form.fim_vigencia_atual =
        this.currentPolicy.fim_vigencia &&
        this.formatDateToDDMMYYYY(this.currentPolicy.fim_vigencia);
      this.form.importancia_segurada_atual = _.clone(
        this.currentPolicy.valor_importancia_segurada
      );
      this.form.fim_vigencia = this.formatDateToDDMMYYYY(
        this.currentPolicy.fim_vigencia
      );
      this.form.novo_fim_vigencia = this.formatDateToDDMMYYYY(
        this.currentPolicy.fim_vigencia
      );

      if (this.newRequest) {
        this.form.tipo = _.cloneDeep(this.cancelType);
      }

      if (!this.form.processo) {
        this.form.processo = _.cloneDeep(MOCK_FORM.processo);
      }

      if (this.$route.params.endosso) {
        this.form.solicitacao = { id: this.$route.params.endosso };
      }

      if (this.editRequestEndorsement) {
        return this.updateEditForm();
      }

      this.cloneForm = _.cloneDeep(this.form);
    },
    updateEditForm() {
      if (_.isEmpty(this.currentRequestEndorsement)) {
        return;
      }

      if (this.currentRequestEndorsement.segurado) {
        this.form.segurado = _.cloneDeep(
          this.currentRequestEndorsement.segurado
        );
      }
      if (this.currentRequestEndorsement.processo) {
        this.form.processo = _.cloneDeep(
          this.currentRequestEndorsement.processo
        );
      }
      if (this.currentRequestEndorsement.novo_fim_vigencia) {
        this.form.novo_fim_vigencia = this.formatDateToDDMMYYYY(
          this.currentRequestEndorsement.novo_fim_vigencia
        );
      }
      if (this.currentRequestEndorsement.valor_importancia_segurada) {
        this.form.valor_importancia_segurada = _.clone(
          this.currentRequestEndorsement.valor_importancia_segurada
        );
      }
      this.form.numero_controle_interno = _.clone(
        this.currentRequestEndorsement.numero_controle_interno
      );
      this.form.anexos = _.cloneDeep(this.currentRequestEndorsement.anexos);
      this.form.motivo_cancelamento = _.cloneDeep(
        this.currentRequestEndorsement.motivo_cancelamento
      );
      this.form.numero = _.clone(this.currentRequestEndorsement.numero);
      this.form.observacoes = _.clone(
        this.currentRequestEndorsement.observacoes
      );

      this.form.informacoes_adicionais = _.clone(
        this.currentRequestEndorsement.informacoes_adicionais
      );

      if (this.currentRequestEndorsement.comentario) {
        this.form.comentario = _.clone(
          this.currentRequestEndorsement.comentario
        );
      }

      this.form.tipo = _.cloneDeep(this.currentRequestEndorsement.tipo);

      if (this.currentRequestEndorsement.numero_endosso_cancelamento)
        this.form.numero_endosso_cancelamento = this.currentRequestEndorsement.numero_endosso_cancelamento;

      if (this.form.fator_premio == null) {
        // Essa mesma regra é usada em created() do PolicyFormSection.vue
        // Por alguma razão dá erro clonar o form, o fator_premio fica nulo no clone
        // e inclusive no próprio form fica estranho... Se algum dia for descoberto o
        // motivo precisa ser arrumado isso aqui.
        this.form.fator_premio = _.cloneDeep(TYPE_PAYMENT);
      }

      this.cloneForm = _.cloneDeep(this.form);
    },
    previousPage() {
      this.modal = false;
      this.$router.push({
        name: "details policy",
        params: { id: this.$route.params.id }
      });
    }
  },
  watch: {
    currentPolicy() {
      this.updateForm();
    },
    currentRequestEndorsement() {
      this.updateForm();
    }
  }
};
